export default __webpack_public_path__ + "static/media/tron.196acf9d.webp";